module.exports = __webpack_public_path__ + "static/img/loading.5bfb154.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 4
// module chunks = 1